

export const episodes = {
  '1': 'https://www.netflix.com/watch/80174386?trackId=13752289&tctx=0%2C1%2Cf7095036fa255a1577391c16edbc6249ecf0a6ec%3Ad66d80365c0697a1c9e1fca7ed06340d33145c35%2Cf7095036fa255a1577391c16edbc6249ecf0a6ec%3Ad66d80365c0697a1c9e1fca7ed06340d33145c35%2Cunknown%2C%2C',
  '2': 'https://www.netflix.com/watch/81001394?trackId=13752289',
  '3': 'https://www.netflix.com/watch/81001395?trackId=200257858',
  '4': 'https://www.netflix.com/watch/81001396?trackId=200257858',
  '5': 'https://www.netflix.com/watch/81001397?trackId=200257858',
  '6': 'https://www.netflix.com/watch/81001398?trackId=200257858',
  '7': 'https://www.netflix.com/watch/81001399?trackId=200257858',
  '8': 'https://www.netflix.com/watch/81001400?trackId=200257858',
  '9': 'https://www.netflix.com/watch/81001401?trackId=200257858',
  '10': 'https://www.netflix.com/watch/81001402?trackId=200257858',
  '11': 'https://www.netflix.com/watch/81106565?trackId=200257858',
  '12': 'https://www.netflix.com/watch/81106566?trackId=200257858',
  '13': 'https://www.netflix.com/watch/81106567?trackId=200257858',
  '14': 'https://www.netflix.com/watch/81106568?trackId=200257858',
  '15': 'https://www.netflix.com/watch/81106569?trackId=200257858',
  '16': 'https://www.netflix.com/watch/81106570?trackId=200257858',
  '17': 'https://www.netflix.com/watch/81106571?trackId=200257858',
  '18': 'https://www.netflix.com/watch/81106572?trackId=200257858',
  '19': 'https://www.netflix.com/watch/81106573?trackId=200257858',
  '20': 'https://www.netflix.com/watch/81106574?trackId=200257858',

}
